// Core
import React from 'react';

// Libraries
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

// Types
import { Theme } from '../../../../../../../../types/theme';

// Plugins
import {
  booleanToEnabled,
  booleanToEnableStatus,
} from '../../../../../../../../plugins/crusher';

// Components
import { Col } from '../../../../../../../../layout/elements/Col';
import { EnableItem } from '../../../../../../../../components/EnableItem';
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../../../../../../../layout/elements/Paragraph';
import { Row } from '../../../../../../../../layout/elements/Row';

// Component
import { SensorsProps } from './Sensors.types';
import {
  EnableItemsContainer,
  LabelsContainer,
  LastEnableItemsContainer,
  LastSeparator,
  SensorsContainer,
  Separator,
} from './Sensors.style';

function Sensors({
  className,
  edgeStatus,
  testId,
  unitData,
}: SensorsProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();
  const theme: Theme = useTheme();

  return (
    <div className={className} data-testid={testId}>
      <Paragraph size={ParagraphSize.lg} weight={ParagraphWeight.bold}>
        {t('view.crusher.vsi.maintenance.setup.sensors.title')}
      </Paragraph>
      <Row>
        <Col cols={12}>
          <SensorsContainer>
            <LabelsContainer>
              <Paragraph
                size={ParagraphSize.sm}
                color={
                  theme.color.crusherDashboard.maintenance.setup.sensors.descriptionTextColor
                }
              >
                {t('common.status')}
              </Paragraph>
              <Paragraph
                size={ParagraphSize.sm}
                color={
                  theme.color.crusherDashboard.maintenance.setup.sensors.descriptionTextColor
                }
              >
                {t('common.sensor')}
              </Paragraph>
            </LabelsContainer>
            <Separator />
            <EnableItemsContainer>
              <EnableItem
                description={t('view.crusher.vsi.maintenance.setup.sensors.crusherSpeedMonitorEnable')}
                enabled={booleanToEnabled(unitData?.crusherSpeedMonitorEnable)}
                status={booleanToEnableStatus(
                  unitData?.crusherSpeedMonitorEnable,
                  edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
                  unitData?.timestamp ? unitData?.timestamp : null,
                )}
              />
              <EnableItem
                description={t('view.crusher.vsi.maintenance.setup.sensors.beltSlipMonitorEnable')}
                enabled={booleanToEnabled(unitData?.beltSlipMonitorEnable)}
                status={booleanToEnableStatus(
                  unitData?.beltSlipMonitorEnable,
                  edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
                  unitData?.timestamp ? unitData?.timestamp : null,
                )}
              />
              <EnableItem
                description={t('view.crusher.vsi.maintenance.setup.sensors.vibrationSensor1')}
                enabled={booleanToEnabled(unitData?.vibrationSensor1Enable)}
                status={booleanToEnableStatus(
                  unitData?.vibrationSensor1Enable,
                  edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
                  unitData?.timestamp ? unitData?.timestamp : null,
                )}
              />
            </EnableItemsContainer>
          </SensorsContainer>
        </Col>
        <Col cols={12}>
          <SensorsContainer>
            <LabelsContainer>
              <Paragraph
                size={ParagraphSize.sm}
                color={
                  theme.color.crusherDashboard.maintenance.setup.sensors.descriptionTextColor
                }
              >
                {t('common.status')}
              </Paragraph>
              <Paragraph
                size={ParagraphSize.sm}
                color={
                  theme.color.crusherDashboard.maintenance.setup.sensors.descriptionTextColor
                }
              >
                {t('common.sensor')}
              </Paragraph>
            </LabelsContainer>
            <LastSeparator />
            <LastEnableItemsContainer>
              <EnableItem
                description={t('view.crusher.vsi.maintenance.setup.sensors.lubeSupplyTempEnable')}
                enabled={booleanToEnabled(unitData?.lubeSupplyTempEnable)}
                status={booleanToEnableStatus(
                  unitData?.lubeSupplyTempEnable,
                  edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
                  unitData?.timestamp ? unitData?.timestamp : null,
                )}
              />
              <EnableItem
                description={t('view.crusher.vsi.maintenance.setup.sensors.metalDetectorEnable')}
                enabled={booleanToEnabled(unitData?.metalDetectorEnable)}
                status={booleanToEnableStatus(
                  unitData?.metalDetectorEnable,
                  edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
                  unitData?.timestamp ? unitData?.timestamp : null,
                )}
              />
            </LastEnableItemsContainer>
          </SensorsContainer>
        </Col>
      </Row>
    </div>
  );
}

export { Sensors };
